import FilterModel from 'app/components/FilterModel';
import NewAttachment from 'app/components/NewAttachment';
import NewInput from 'app/components/NewInput';
import SearchableDropdown from 'app/components/SearchableDropdown';
import TextArea from 'app/components/Textarea';
import NumberInput from 'app/components/UI/NumberInput';
import { commonMaxDate, commonMinDate } from 'app/utils/Parsers';

// Side panel for one voucher inside the package form. Presentational only:
// everything arrives through props. Mode 'add' appends a new draft voucher;
// mode 'save' reopens an existing entry pre-filled (D-01).
const PackageVoucherPanel = ({
  isOpen,
  mode,
  values,
  error,
  storeList,
  onChange,
  onUploadImage,
  onSubmit,
  onClose,
}) => {
  const isSave = mode === 'save';
  // New dates start from today, but a voucher that has already started keeps
  // its stored start date valid, so the panel can still be saved.
  const today = commonMinDate();
  const startMin =
    values?.startDate && values.startDate < today ? values.startDate : today;

  // FilterModel renders a real <form>, so submit-on-Enter fires it. Guard on
  // native validity first, as CollectionPanel/CollectVoucher.js does.
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (form.checkValidity()) {
      onSubmit();
    } else {
      form.reportValidity();
    }
  };

  return (
    <FilterModel
      isFilterOpen={isOpen}
      setIsFilterOpen={onClose}
      onCancel={onClose}
      onSubmit={handleSubmit}
      filter={false}
      heading={isSave ? 'Edit Voucher' : 'Add Voucher'}
      submitLabel={isSave ? 'Save' : 'Add to bundle'}
    >
      {/* Fields mount only while open: a reopened panel starts fresh, and the
          closed panel leaves no duplicate ids in the page. */}
      {isOpen && (
        <>
          <div className='offcanvas-item'>
            <SearchableDropdown
              id='panelStoreId'
              label='Store name*'
              name='storeId'
              options={storeList}
              placeholder='Search store...'
              value={values?.storeId}
              handleChange={onChange}
              errorText={error?.storeId}
            />
          </div>
          <div className='offcanvas-item'>
            <NewInput
              label='Voucher title*'
              id='panelVoucherTitle'
              type='text'
              placeholder='Voucher title'
              name='voucherTitle'
              maxLength={255}
              value={values?.voucherTitle}
              onChange={onChange}
              errorText={error?.voucherTitle}
            />
          </div>
          <div className='offcanvas-item'>
            <label>Voucher Promotional Image </label>
            <NewAttachment
              value={values?.promotionalImage}
              id='panelPromotionalImage'
              onFileSelected={(file) => onUploadImage(file)}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              alt='promotionalImage'
              errorText={error?.promotionalImage}
            />
          </div>
          <div className='offcanvas-item'>
            <TextArea
              label='Description*'
              id='panelDescription'
              type='text'
              placeholder='Description'
              name='description'
              maxLength={2000}
              value={values?.description}
              onChange={onChange}
              errorText={error?.description}
            />
          </div>
          <div className='offcanvas-item'>
            <NumberInput
              label='Loyalty Points*'
              id='panelLoyaltyPoints'
              placeholder='Enter loyalty points'
              name='loyaltyPoints'
              value={values?.loyaltyPoints}
              onChange={onChange}
              errorText={error?.loyaltyPoints}
            />
          </div>
          <div className='offcanvas-item'>
            <NewInput
              label='Start Date*'
              id='panelStartDate'
              name='startDate'
              type='date'
              min={startMin}
              max={commonMaxDate()}
              value={values?.startDate}
              onChange={onChange}
              errorText={error?.startDate}
            />
          </div>
          <div className='offcanvas-item'>
            <NewInput
              label='Expiry Date*'
              id='panelExpiryDate'
              name='expiryDate'
              type='date'
              min={values?.startDate ? values.startDate : today}
              max={commonMaxDate()}
              value={values?.expiryDate}
              onChange={onChange}
              errorText={error?.expiryDate}
            />
          </div>
        </>
      )}
    </FilterModel>
  );
};

export default PackageVoucherPanel;
